import React from "react";
import { Link } from "react-router-dom";
import logo from "images/only4kidsLogo-removebg-preview.png";

const Logo = () => {
  return (
    <Link to="/">
      <img src={logo} alt="" width={"350px"} />
    </Link>
  );
};

export default Logo;
